import { render } from "./OrderConfirm.vue?vue&type=template&id=3f0255ff&scoped=true&ts=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=ts"
export * from "./OrderConfirm.vue?vue&type=script&lang=ts"

import "./OrderConfirm.vue?vue&type=style&index=0&id=3f0255ff&scoped=true&lang=scss"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0255ff"]])

export default __exports__